import React from 'react';
import { Image ,  Header, Container  } from 'semantic-ui-react';
import NoSearchFoundImage from './../../images/grafix-banner/gfx-no-data.svg'
class NoDataToDisplay extends React.Component {

    redirect() {
        const history = this.props.history;
        history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/team/asdasdasd`);
    }
    render() {

        return (
            <Container fluid className="pad_40">
            <Image src={NoSearchFoundImage} size='medium' centered={true} />
            <Header as='h3' icon textAlign='center'>
                <Header.Content >
                    No data to display!
                 <br />  <br />
                </Header.Content>
                
            </Header>
        </Container>
        )
    }
}

export default NoDataToDisplay
